import { useLocalStorage } from '@vueuse/core'
import { isApp, tcGetLoginInfo } from './bridge'

// 此 token 仅用于 H5 环境
// App 环境下的 token 存储在客户端，通过 bridge 获取
const token = useLocalStorage('qx_token', '')

/**
 * 获取 token
 * 
 * App 环境：每次都从 Native 获取（不缓存，避免同步问题）
 * H5 环境：从 localStorage 读取
 */
async function getToken(): Promise<string> {
  if (isApp()) {
    // App 环境：每次都从 Native 获取最新的 token
    return tcGetLoginInfo()
  } else {
    // H5 环境：从 localStorage 读取
    return token.value || ''
  }
}

/**
 * 检查是否已登录
 * 
 * App 环境：从 Native 获取 token 并判断
 * H5 环境：检查 localStorage
 */
async function isLogin(): Promise<boolean> {
  const tokenValue = await getToken()
  return !!tokenValue
}

/**
 * 设置 token
 * 注意：仅用于 H5 环境登录后存储
 * App 环境下 token 由客户端管理，无需调用此方法
 */
function setToken(newToken: string) {
  if (!isApp()) {
    token.value = newToken
  } else {
    console.warn('[Auth] App 环境下 token 由客户端管理，无需调用 setToken')
  }
}

/**
 * 清除 token
 * 注意：仅用于 H5 环境退出登录
 * App 环境下 token 由客户端管理，无需调用此方法
 */
function clearToken() {
  if (!isApp()) {
    token.value = null
  } else {
    console.warn('[Auth] App 环境下 token 由客户端管理，无需调用 clearToken')
  }
}

export { isLogin, getToken, setToken, clearToken }
